import React, { useState, useEffect, useRef } from 'react';
import SummaryBlock from '../../components/SummaryBlock/SummaryBlock'
import OperationItem from '../../components/Operations/OperationItem'
import MapContainer from '../../components/DealersMap/MapContainer'
import Headline from '../../components/Title/Headlines'
import './OperationsPage.scss'
import { useSelector, useDispatch } from 'react-redux';
import { isMobile } from '../../helpers/helpers';
import fetchApiData from '../../apiHandlers/fetchApiData';
import CONSTANTS from '../../Constants';
import {
    setSelectedOperationsToStore,
    setSelectedForfaitsToStore,
    setSelectedMandatoryAdditionalForfaitsToStore,
    setSelectedMileageStep
} from '../../redux-files/actions/action';
import { Button } from '../../components/Forms/Forms';
import OperationsDetail from '../../components/Operations/OperationsDetail';
import OperationsLoader from '../../components/Operations/OperationsLoader';
import { useNavigate } from 'react-router-dom';
import OperationStepsMobile from '../../components/Operations/MobileOperationsComponents/OperationStepsMobile';
import MobileStickyBlock from '../../components/mobile-sticky-block/mobileStickyBlock';
import useBodyClass from '../../custom-Hooks/useBodyClass';
import { pushToGTMTracker, pushEventToGTM } from '../../helpers/trackerManager';
import MobileMailPopinForm from '../../components/MobileMailPopinForm/MobileMailPopinForm';

const OperationsPage = () => {
    const detailsRef = useRef(null);
    const dealer = useSelector(state => state.ndel_store.dealer)
    const vehicleInfo = useSelector(state => state.ndel_store.vehicleInfo)
    const selectedForfaitFromStore = useSelector(state => state.ndel_store.selectedForfaits)
    const selectedMandatoryAdditionalForfFromStore = useSelector(state => state.ndel_store.selectedMandatoryAdditionalForfaits)
    const storeSelectedOperations = useSelector(state => state.ndel_store.selectedOperations)
    const addressSearch = useSelector(state => state.ndel_store.addressSearch)
    const [searchedAddress, setSearchedAddress] = useState(addressSearch)
    const [selectedOperations, setSelectedOperations] = useState(storeSelectedOperations)
    const [operationsLoading, setOperationsLoading] = useState(true)
    const [goToNextStep, setGoToNextStep] = useState(false)
    const [selectedOperation, setSelectedOperation] = useState({})
    const [totalPrice, setTotalPrice] = useState(0)
    const [showMap, setShowMap] = useState(false)
    const [interventionsList, setInterventionList] = useState({ forfaitsList: [], familyList: [] })
    const [showMailForm, setShowMailForm] = useState(false)
    const [redirectToBooking, setRedirectToBooking] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(10);

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const REVIS_CONSTRU_CODE_FAMLILY = 'FCT0002'
    useEffect(() => {
        console.log('OperationPage useEffect run ...')
        window.scrollTo(0, 0)
        if (!(dealer.iD !== 0 && !dealer.editDealer)) {
            setShowMap(true)
        } else {
            setShowMap(false)
            loadOperations()
            pushToGTMTracker('operation-page', window.siteConfig.quotingPrestations.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()), dealer)

        }
        let totPrice = 0
        selectedForfaitFromStore.map(forfait => {
            totPrice = totPrice + forfait.Items[0].Prix
            if (forfait.forfaitFamilyCode === REVIS_CONSTRU_CODE_FAMLILY) {
                selectedMandatoryAdditionalForfFromStore.map(mandOp => {
                    totPrice += mandOp.Items[0].Prix
                })
            }
        })
        setTotalPrice(totPrice)

    }, [dealer]);

    useEffect(() => {
        const idpdv = dealer?.geoID;
        const redirectTimer = setInterval(() => {
        if(redirectToBooking){
            setSecondsLeft((prevState) => {
            if(prevState>0) return prevState - 1
            else if (prevState === 0) {
                window.location.href = `/booking.aspx?idpdv=${idpdv}`;
                return prevState;
            }
            });
        }
         
    }, 1000);    
    return () => {
      clearInterval(redirectTimer);
    };
    }, [redirectToBooking])
    
    const loadOperations = () => {
        const getForfaitsAPI = new fetchApiData()
        getForfaitsAPI.getForfait({
            "brandCode": CONSTANTS.SITE_INFO.BRAND_CODE,
            "cultureCode": CONSTANTS.SITE_INFO.CULTURE,
            "idDealer": dealer.iD,
            "serialNumber": vehicleInfo.SerialNumber,
            "modelCode": vehicleInfo.ModelCode,
            "motorCode": vehicleInfo.MotorCode,
            "lcdv": vehicleInfo.Lcdv,
            "energyLabel": vehicleInfo.EnergyLabel,
            "mileage": vehicleInfo.Mileage,
            "registration": vehicleInfo.Registration,
            "serviceContract": vehicleInfo.contratService

        }).then(
            res => {
                if (res.d.FamilyList.ErrorCode === 0)
                    setInterventionList({ forfaitsList: res.d.FunctionList, familyList: res.d.FamilyList.listeIntervention });
                    setOperationsLoading(false)
                    if(res.d.FamilyList.listeIntervention.length === 0){
                        setRedirectToBooking(true)
                    }
            })
            .catch(error => {
                console.warn(error);
                setOperationsLoading(false);
                setRedirectToBooking(true);  
            });
    }
    const CheckAlreadyAdded = (id) => {
        const filtredOperations = Object.values(selectedOperations).filter(item => item.interventionId === id);
        return filtredOperations.length > 0;
    }
    const removeOrAddToSelectedOperations = (operation) => {
        const interventionForfaits = interventionsList.forfaitsList.filter(item => operation.codeFamilyForfait.indexOf(item.Code) != -1)
        const isForfaitsBlockOpen = false
        let updatedOperation = { ...operation, interventionForfaits, isForfaitsBlockOpen }
        if (!CheckAlreadyAdded(operation.interventionId)) {
            if (isMobile()) {
                setGoToNextStep(true)
                setSelectedOperation(updatedOperation)
            }
            setSelectedOperations([...selectedOperations, updatedOperation])
            dispatch(setSelectedOperationsToStore([...selectedOperations, updatedOperation]))
        }
        else {
            setSelectedOperations(selectedOperations.filter(item => item.interventionId !== updatedOperation.interventionId))
            dispatch(setSelectedOperationsToStore(selectedOperations.filter(item => item.interventionId !== updatedOperation.interventionId)))
            let filtredSelectedFofraits = selectedForfaitFromStore.filter(forfait => !(updatedOperation.interventionForfaits.some(intervForf => intervForf.Code === forfait.forfaitFamilyCode)));
            let deSelectedFofraits = selectedForfaitFromStore.filter(forfait => (updatedOperation.interventionForfaits.some(intervForf => intervForf.Code === forfait.forfaitFamilyCode)));
            deSelectedFofraits.forEach(item => item.isChecked = false)
            console.log(updatedOperation)
            updatedOperation.interventionForfaits.forEach(intervForf => {
                if (!intervForf.isConstructeur) {
                    intervForf.SubFunctionList[0].ForfaitList.forEach(forf => {
                        forf.isChecked = false
                    })
                }

            })
            console.log(updatedOperation)
            dispatch(setSelectedForfaitsToStore(filtredSelectedFofraits));
            if (updatedOperation.codeFamilyForfait === REVIS_CONSTRU_CODE_FAMLILY) {
                dispatch(setSelectedMandatoryAdditionalForfaitsToStore([]))
                dispatch(setSelectedMileageStep({ 'key': '', 'value': CONSTANTS.LABELS.needs_basket_maintenance_label5 }))
            }
            if (isMobile) {
                let finalPrice = totalPrice
                deSelectedFofraits.forEach(forfait => {
                    finalPrice = finalPrice - forfait.Items[0].Prix
                })
                if (updatedOperation.codeFamilyForfait === REVIS_CONSTRU_CODE_FAMLILY) {
                    selectedMandatoryAdditionalForfFromStore.forEach(mandForf => {
                        finalPrice = finalPrice - mandForf.Items[0].Prix
                    })
                }
                setTotalPrice(finalPrice)
                setGoToNextStep(false)
            }
        }
    }
    const isButtonDisabled = () => {
        let isOperationsWithForfait = selectedOperations.map(operation => {
          // /* New traitement
          let isSomeChecked = false;
            operation.interventionForfaits.map( intervention => {
                if( !intervention.isConstructeur){
                    intervention.SubFunctionList.map( list => {
                        if(list.ForfaitList.some(forfait => forfait.isChecked)){
                            isSomeChecked = true;
                        }
                    })
                }
                else {
                    return selectedForfaitFromStore.some(forf => forf.forfaitFamilyCode === REVIS_CONSTRU_CODE_FAMLILY)
                }
            })
            return isSomeChecked;
            //*/
            
           /* OLD traitement  
           if (!operation.interventionForfaits[0].isConstructeur) {
                return operation.interventionForfaits[0].SubFunctionList[0].ForfaitList.some(forfait => forfait.isChecked)
            }
            else {
                return selectedForfaitFromStore.some(forf => forf.forfaitFamilyCode === REVIS_CONSTRU_CODE_FAMLILY)
            }
            //*/
        })
        if (isOperationsWithForfait.length <= 0) {
            return true
        }
        return !isOperationsWithForfait.every(item => item)
    }
    const continueToNextStep = () => {
        pushEventToGTM({
            pageName: 'services',
            eventAction: 'Redirection::Internal::Next_step',
            eventLabel: CONSTANTS.LABELS.common_v2_continue,
            eventCategory: 'content'
        })

        navigate(CONSTANTS.SITE_ROUTS.YOURQUOTEPAGE)
    }
    useBodyClass(`page-operations`)

    const scrollToNext = () => {
        if (detailsRef.current) {
            detailsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };
    return (
        <>
            <div ref={detailsRef}> 
            {!goToNextStep ?
                <>
                    <SummaryBlock handleDealerSearch={(searchedAdress) => { setSearchedAddress(searchedAdress) }} showDealerSearch={() => setShowMap(true)} />
                    {!showMap && <Headline
                        Title={CONSTANTS.LABELS.needs_title}
                        SubTitle={CONSTANTS.LABELS.needs_subtitle1}
                    />}
                    <div className='content-wrapper'>
                        <div className='content-container'>
                            {showMap && <MapContainer addressSearch={searchedAddress} closeDealersMap={() => setShowMap(false)} />}
                            {
                                !operationsLoading ?
                                    <ul className='opertions-list'>
                                        {interventionsList.familyList.map((operation, key) => {
                                            const isShowed = operation.Quoting ;
                                            return (
                                                isShowed ?
                                                <OperationItem
                                                    scrollToNext={scrollToNext}
                                                    title={operation.interventionLabel}
                                                    icon={operation.Image}
                                                    id={operation.interventionId}
                                                    key={`${operation.interventionId}-${key}`}
                                                    isChecked={CheckAlreadyAdded(operation.interventionId)}
                                                    handlClick={() => removeOrAddToSelectedOperations(operation)}
                                                />
                                                :
                                                ''
                                            )
                                        })}
                                    </ul> :
                                    <OperationsLoader />
                            }
                            {redirectToBooking && 
                                <div 
                                style={{
                                    backgroundColor : "white", 
                                    textAlign: "center", 
                                    marginBottom : "1em", 
                                    fontSize : isMobile() ? "14px" : "20px"
                                }}>
                                    <div>{CONSTANTS.LABELS.needs_error_package1} </div>
                                    <div>
                                    {`${CONSTANTS.LABELS.needs_error_package2} ${secondsLeft} ${CONSTANTS.LABELS['rdv-forfait_redirectionmessage2']}`}
                                    </div>
                                </div>
                            }
                            {!isMobile() && <OperationsDetail selectedOperations={selectedOperations} handleRemove={(operation) => removeOrAddToSelectedOperations(operation)} />}
                        </div>

                    </div>
                    {isMobile() ?

                        <MobileStickyBlock
                            labels={[
                                CONSTANTS.LABELS.needs_basket_maintenance_label9,
                                CONSTANTS.LABELS.quote_nopackage,
                                CONSTANTS.LABELS.needs_basket_label2,
                                CONSTANTS.LABELS.quote_mobile_send_email,
                                CONSTANTS.LABELS.quote_mobile_view,
                                CONSTANTS.LABELS.quote_booking
                            ]}
                            selectedOperations={selectedOperations}
                            totalPrice={totalPrice}
                            handleFirstButton={() => setShowMailForm(true)}
                            handleSeconButton={() => navigate(CONSTANTS.SITE_ROUTS.YOURQUOTEPAGE)}
                            handleThirdButton={() => navigate(CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE)}
                        ></MobileStickyBlock>
                        :
                        <div className='sticky-button-block'>
                            <Button isDisabled={isButtonDisabled()}
                                handlClick={continueToNextStep}
                            >
                                {CONSTANTS.LABELS.common_v2_continue}
                            </Button>
                        </div>
                    }
                    {isMobile() && showMailForm && < MobileMailPopinForm handleGoBackClick={() => setShowMailForm(false)} />}

                </>
                : isMobile() && <OperationStepsMobile
                    handleGoBack={() => setGoToNextStep(false)}
                    handleClick={(totalPrice) => {
                        setGoToNextStep(false);
                        setTotalPrice(totalPrice);
                        window.scrollTo(0, 0)
                    }}
                    selectedOperation={selectedOperation}
                    onDeleteOperation={removeOrAddToSelectedOperations}
                />
            }
            </div>

        </>
    );

    

}

export default OperationsPage;
